module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/negativo_hover.7e2d5ea7.svg";